import {wc} from '@woocommerce/blocks-registry';
import {getSettings} from "../util";
import {LocalPaymentIntentContent} from './local-payment-method';
import {PaymentMethodLabel, PaymentMethod} from "../../components/checkout";
import {canMakePayment} from "./local-payment-method";
import {FpxBankElement} from "@stripe/react-stripe-js";

const getData = getSettings('stripe_fpx_data');

if (getData()) {
	wc.registerPaymentMethod({
		name: getData('name'),
		label: <PaymentMethodLabel
			title={getData('title')}
			paymentMethod={getData('name')}
			icons={getData('icon')}
		/>,
		ariaLabel: 'FPX',
		placeOrderButtonLabel: getData('placeOrderButtonLabel'),
		canMakePayment: canMakePayment(getData),
		content: <PaymentMethod
			content={LocalPaymentIntentContent}
			getData={getData}
			confirmationMethod={'confirmFpxPayment'}
			component={FpxBankElement}
		/>,
		edit: <PaymentMethod content={LocalPaymentIntentContent} getData={getData}/>,
		supports: {
			showSavedCards: false,
			showSaveOption: false,
			features: getData('features')
		}
	})
}